import { px2rem } from '@/utils/px2rem';

// px2rem指令
const px2remDirective = {
  bind(el, binding) {
    const { value, arg } = binding;
    
    if (typeof value === 'number') {
      // 如果值是数字，直接转换
      el.style[arg || 'fontSize'] = px2rem(value);
    } else if (typeof value === 'object') {
      // 如果值是对象，批量转换样式
      Object.keys(value).forEach(key => {
        if (typeof value[key] === 'number') {
          el.style[key] = px2rem(value[key]);
        } else {
          el.style[key] = value[key];
        }
      });
    }
  },
  
  update(el, binding) {
    // 更新时重新应用样式
    this.bind(el, binding);
  }
};

// 响应式指令
const responsiveDirective = {
  bind(el, binding) {
    const { value } = binding;
    
    if (typeof value === 'function') {
      // 如果值是函数，执行函数获取样式
      const styles = value();
      Object.keys(styles).forEach(key => {
        if (typeof styles[key] === 'number') {
          el.style[key] = px2rem(styles[key]);
        } else {
          el.style[key] = styles[key];
        }
      });
    }
  },
  
  update(el, binding) {
    this.bind(el, binding);
  }
};

export default {
  px2rem: px2remDirective,
  responsive: responsiveDirective
};

